import { useMemo } from 'react';
import { Icon, Button, PopoverMenu } from '@pwc/pwc-deals-ui';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getEditNavigationLink } from '../../utils/groupsUtilities';
import styles from './AnalysisMenu.module.scss';
import useMobile from '../../../../common/hooks/useMobile';

type Props = {
  projectId: number;
  analysisId: number;
  subType: number;
  type: number;
  handleDelete: (id: number) => void;
  handleMove: () => void;
  enableDragAndDrop: boolean;
  isDisabled: boolean;
  lockingUserName?: string;
};

const AnalysisMenu: React.FC<Props> = ({
  projectId,
  handleDelete = null,
  handleMove = null,
  analysisId = null,
  subType,
  enableDragAndDrop = true,
  isDisabled,
  lockingUserName,
  type,
}): JSX.Element => {
  const history = useHistory();
  const isMobile = useMobile();
  const getMessage = (name: string) =>
    `Unable to edit or delete the item as ${name} is currently editing.`;

  const handleEdit = () => {
    const editLink = getEditNavigationLink(
      projectId,
      analysisId as number,
      subType,
      type
    );
    history.push(editLink);
  };
  const { t } = useTranslation();

  return useMemo(
    () => (
      <PopoverMenu
        id="analyses-group"
        className="analysis-menu"
        placement="left-start"
        isButtonSecondary
      >
        <div className="analysis-menu__pop">
          <Button
            className="button-menu button"
            onClick={handleEdit}
            icon=""
            iconClasses=""
            disabled={isDisabled || isMobile}
          >
            <Icon
              name="pencil"
              width="24"
              className="sr2 outline icon-orange"
            />
            {t('analysisMenuEdit')}
          </Button>

          {handleDelete && (
            <Button
              className="button-menu button"
              onClick={() => handleDelete(analysisId as number)}
              icon=""
              iconClasses=""
              disabled={isDisabled}
            >
              <Icon name="bin" width="24" className="sr2 outline icon-orange" />
              {t('analysisMenuDelete')}
            </Button>
          )}
          {handleMove && enableDragAndDrop && (
            <Button
              onClick={handleMove}
              icon=""
              className="button-menu button"
              iconClasses=""
            >
              <Icon
                name="move"
                width="24"
                className="sr2 outline icon-orange"
              />
              {t('analysisMenuMoveToGroup')}
            </Button>
          )}
          {isDisabled && lockingUserName && (
            <div className={styles.warningMessageContainer}>
              <div className={styles.iconContainer}>
                <Icon
                  name="information"
                  width="18"
                  className="sr2 fill icon-yellow"
                />
              </div>
              <div className={styles.userNameContainer}>
                {getMessage(lockingUserName)}
              </div>
            </div>
          )}
        </div>
      </PopoverMenu>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isDisabled]
  );
};

export default AnalysisMenu;
